import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { NotificationType } from '../enum/notification-type.enum';
import { UserManagementModel } from '../models/userManagementModel/usermang.model';
import { NotificationService } from './notification.service';

const USER_KEY = 'auth-user';
const TOKEN_KEY = 'auth-token';

@Injectable({
  providedIn: 'root',
})

export class AuthGaurdService implements CanActivate {
  loginUserName: any = '';
  getNetworkId: any = '';
  getEmployeeId: any = '';
  nid: any = '';
  loggedInEmail: string;
  isImpersonate: boolean = false;
  loggedInEmployeeId: any = '';
  menuSubMenuData: UserManagementModel[] = [];
  token: string;
  imPersonUser: string = '';
  favData: UserManagementModel;
  isFavourite: boolean = true;
  userRole: string = '';
  response: string = '';

  constructor(private router: Router,
    private msalService: MsalService,
    private http: HttpClient, private notificationService: NotificationService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    console.log("canActivate called");

    // Check for session timeout state first
    const sessionTimeoutState = localStorage.getItem('session-timeout-state');
    const popupActive = localStorage.getItem('session-popup-active');
    if (sessionTimeoutState && popupActive === 'true') {
      const sessionData = JSON.parse(sessionTimeoutState);
      const timeSinceLastActivity = Date.now() - sessionData.lastActivity;
      const SESSION_TIMEOUT = 60 * 60 * 1000; // 60 minutes - should match UserActivityService
      if (timeSinceLastActivity >= SESSION_TIMEOUT) {
        console.warn("Session has expired. Redirecting to home.");
        // Clear the session timeout state
        localStorage.removeItem('session-timeout-state');
        localStorage.removeItem('session-popup-active');
        this.router.navigate(['/']);
        return false;
      }
    }

    const accounts = this.msalService.instance.getAllAccounts();
    //console.log("accounts.length =", accounts.length);
    if (accounts.length === 0) {
      console.warn("No accounts found. Redirecting to home.");
      this.router.navigate(['/']);
      return false;
    }

    // Set active account
    this.msalService.instance.setActiveAccount(accounts[0]);

    // Get allowed roles from route data
    const allowedRoles = route.data['roles'] as string[] || [];
    //console.log("allowedRoles =", allowedRoles);

    // Get user roles from localStorage
    const userRolesRaw = localStorage.getItem('CURRENT_USERROLE_SESSION');
    if (!userRolesRaw) {
      console.warn("No user roles found in session. Redirecting.");
      this.router.navigate(['/']);
      return false;
    }

    const userRoles = userRolesRaw.split(',').map(role => role.trim());
    //console.log("userRoles =", userRoles);

    // Check if user has at least one allowed role
    const isAuthorized = allowedRoles.some(role => userRoles.includes(role));
    //console.log("isAuthorized =", isAuthorized);

    if (!isAuthorized) {
      console.warn("User not authorized. Redirecting.");
      this.router.navigate(['/unauthorized']);
      return false;
    }

    console.log("Access granted.");
    return true;
  }


  // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  //   console.log("canActivate called");

  //   if (this.msalService.instance.getAllAccounts().length > 0) {
  //     console.log("Inside IF");
  //     let accounts = this.msalService.instance.getAllAccounts();
  //     this.msalService.instance.setActiveAccount(accounts[0]);

  //     const allowedRoles = route.data['roles'] as string[];
  //     console.log("allowedRoles = " + allowedRoles);
  //     const userRoles = localStorage.getItem('CURRENT_USERROLE_SESSION');
  //     console.log("userRoles = " + userRoles);

  //     const isAuthorized = allowedRoles.some(role => userRoles.includes(role));
  //     console.log("isAuthorized = " + isAuthorized);

  //     if (!isAuthorized) {
  //       console.log("Inside IF");
  //       this.router.navigate(['/']);
  //       //this.router.navigate(['/unauthorized']);
  //       return false;
  //     }
  //     // }
  //     console.log("Before");
  //     return true;
  //   } else {
  //     console.log("Inside ELSE");
  //     this.router.navigate(['/']);
  //     return false;
  //   }
  // }

  public isLoggedIn(): boolean {
    const user = window.sessionStorage.getItem(USER_KEY);
    if (user) {
      return true;
    }

    return false;
  }



   logout() {
    // Clear only application-specific data, not global Microsoft authentication
    this.clearApplicationSession();
    // Use logoutRedirect instead of logout to avoid affecting other Microsoft apps
    // This will redirect to logout page but preserve other app sessions
    this.msalService.logoutRedirect({
      account: this.msalService.instance.getActiveAccount(),
      postLogoutRedirectUri: window.location.origin
    });
  }
 
  private clearApplicationSession(): void {
    // Clear application-specific tokens and data from local storage
    localStorage.removeItem('token');
    localStorage.removeItem('session-state');
    localStorage.removeItem('last-activity');
    localStorage.removeItem('user-activity');
    localStorage.removeItem('NOOOO');
    // Clear session storage
    sessionStorage.removeItem('browser_session_id');
    sessionStorage.removeItem('auth-token');
    sessionStorage.removeItem('auth-user');
    this.signOut();
  }

  signOut(): void {
    console.log("signOut called");
    window.sessionStorage.clear();
  }

  public saveToken(token: string): void {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string | null {
    return window.sessionStorage.getItem(TOKEN_KEY);
  }

  public saveUser(user: any): void {
    window.sessionStorage.removeItem(USER_KEY);
    window.sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): any {
    const user = window.sessionStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }



  public loadToken(): void {
    this.token = localStorage.getItem('token');
  }

  loginUser(): string {
    let activeAccount = this.msalService.instance.getActiveAccount();
    if (activeAccount !== null) {
      this.loginUserName = activeAccount?.name;
      localStorage.setItem('USERNAME_SESSION', JSON.stringify(this.loginUserName));
    }
    return this.loginUserName;
  }

  loginEmployeeId(): string {
    // console.log("loginEmployeeId Called");
    var employeeId = "";
    let activeAccount = this.msalService.instance.getActiveAccount();
    // console.log(activeAccount);
    if (activeAccount !== null) {
      this.getEmployeeId = "[" + JSON.stringify(this.msalService.instance.getActiveAccount().idTokenClaims) + "]";

      var stringify = JSON.parse(this.getEmployeeId);
      employeeId = stringify[0]['employeeid'];
      localStorage.setItem('EMPLOYEEID_SESSION', JSON.stringify(employeeId));
    }
    return employeeId;
  }

  loginNetworkId(): string {
    this.getNetworkId = "[" + JSON.stringify(this.msalService.instance.getActiveAccount().idTokenClaims) + "]";

    var stringify = JSON.parse(this.getNetworkId);
    var networkId = stringify[0]['samAccountName'];
    localStorage.setItem('NETWORKID_SESSION', JSON.stringify(networkId));
    //console.log("Network ID: " + networkId);

    return networkId;
  }

  loginEmail(): string {
    let activeAccount = this.msalService.instance.getActiveAccount();
    this.loggedInEmail = activeAccount?.username;
    //console.log('authService loggedInUsername: ', this.loggedInUsername);
    return this.loggedInEmail;
  }

  public isTokenExpired(token: string) {
    //console.log("isTokenExpired() Called");
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    return expiry * 1000 > Date.now();
  }

  public sendNotification(notificationType: NotificationType, message: string): void {

    if (message) {
      this.notificationService.notify(notificationType, message);
    } else {
      this.notificationService.notify(notificationType, 'An error occurred. Please try again.');
    }
  }

}

export const appConfig = {
  httpOptions: {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  },
  formHttpOptions: {
    headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
  },
}